import { BASE_URL } from "../env";
const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/step`;
const fetch_init_options = {
  method: "POST",
  credentials: "include",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

const deleteCookie = (fn) => {
  fetch(`${base_URL}/activation/ACTDLC`, fetch_init_options)
    .catch((error) => {
      console.log("error : " + error);
      if (fn) fn();
    })
    .then((res) => {
      if (fn) fn();
    });
};
export default deleteCookie;
